import { TFunction } from 'i18next';

import { IOption } from '../../../../../../@types/option';
import { capitalizeFirstLetter } from '../../../../../../utils/formatString';

export enum StudentSkilltrackerProficiencyLevelFiltersEnum {
  ALL = 'all',
  ENTRY_LEVEL = 'Entry-Level',
  MID_LEVEL = 'Mid-Level',
  SENIOR_LEVEL = 'Senior-Level',
}

export const StudentSkilltrackerProficiencyLevelFilters = (t: TFunction): IOption[] => [
  {
    id: capitalizeFirstLetter(StudentSkilltrackerProficiencyLevelFiltersEnum.ALL),
    name: t('ALL'),
  },
  {
    id: StudentSkilltrackerProficiencyLevelFiltersEnum.ENTRY_LEVEL,
    name: t('ENTRY_LEVEL'),
  },
  {
    id: StudentSkilltrackerProficiencyLevelFiltersEnum.MID_LEVEL,
    name: t('MID_LEVEL'),
  },
  {
    id: StudentSkilltrackerProficiencyLevelFiltersEnum.SENIOR_LEVEL,
    name: t('SENIOR_LEVEL'),
  },
];

export default StudentSkilltrackerProficiencyLevelFiltersEnum;
